import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Login, Menu } from './screens/'
import AuthContextProvider, { AuthContext } from './contexts/AuthContext'
import UsuarioContextProvider from './contexts/UsuarioContext'
import CheckoutContextProvider from './contexts/CheckoutContext'
import EmpresasContextProvider from './contexts/EmpresasContext'
import AgendamentoContextProvider from './contexts/AgendamentoContext'
import ChatContextProvider from './contexts/ChatContext'
import { SnackbarProvider } from 'notistack'
import moment from 'moment'

import 'moment/dist/locale/pt-br'
import './styles.css'

moment.locale('pt-br')

export default function AppRouter() {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const rotas_label = {
    login: '/',
    menu: '/*',
    erro404: '*',
  }

  function RouteChangeTracker() {
    return null
  }

  function Rotas() {
    return (
      <Routes>
        <Route path={rotas_label.login} element={<Login />} />
        <Route path={rotas_label.menu} element={<Menu />} />
      </Routes>
    )
  }

  return (
    <Router>
      <AuthContextProvider>
        <UsuarioContextProvider>
          <AgendamentoContextProvider>
            <EmpresasContextProvider>
              <CheckoutContextProvider>
                <SnackbarProvider
                  anchorOrigin={{
                    vertical: sttAuthCtx.isMobile ? 'top' : 'bottom',
                    horizontal: sttAuthCtx.isMobile ? 'center' : 'right',
                  }}
                  style={{
                    borderRadius: sttAuthCtx.isMobile ? 30 : 10,
                    fontSize: sttAuthCtx.isMobile ? 14 : 16,
                  }}
                  autoHideDuration={3000}
                  maxSnack={2}
                  dense={sttAuthCtx.isMobile ? true : false}
                >
                  <ChatContextProvider>
                    <RouteChangeTracker />
                    {Rotas()}
                  </ChatContextProvider>
                </SnackbarProvider>
              </CheckoutContextProvider>
            </EmpresasContextProvider>
          </AgendamentoContextProvider>
        </UsuarioContextProvider>
      </AuthContextProvider>
    </Router>
  )
}

/*
Login: Acessar Conta | Agendei Quadras                    X
Cadastro: Criar Conta | Agendei Quadras                   X              
Redefinir Senha: Redefinir Senha | Agendei Quadras        X
Tela Inicial: Início | Agendei Quadras                    X
Tela da Empresa: NomeDaEmpresa | Agendei Quadras          X
Checkout: Faça seu agendamento | Agendei Quadras          X
Pagar por PIX: Pagamento de PIX | Agendei Quadras         X
Conversas: Conversas | Agendei Quadras                    X     
Minha Agenda: Minha Agenda | Agendei Quadras              X         
Dados Pessoais: Dados Pessoais | Agendei Quadras          X
Aspectos Legais: Aspectos Legais | Agendei Quadras        X

*/
